export default "__VITE_ASSET__CIF2zGez__"